// extracted by mini-css-extract-plugin
module.exports = {"content_container":"AdminChannelResourcesEdit_content_container__1gLGa","contentContainer":"AdminChannelResourcesEdit_content_container__1gLGa"};